// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3be4d951","372":"55f1accc"}[chunkId] + ".chunk.js";
};